import { CitizenshipVM } from 'shell/view-models/citizenship';
import { Citizenship } from 'shell/models/person/citizenship';
import { transformCitizen } from '../citizenship-shared';

export const transformCitizenship = (
  values: Array<CitizenshipVM> | undefined
): Array<Citizenship | undefined> | undefined | Array<Citizenship> => {
  const returnData: Array<Citizenship | undefined> | undefined = values
    ? values.map((citizen) => transformCitizen(citizen))
    : undefined;

  return returnData;
};
